import i18next from 'i18next';
import moment from 'moment';
import { DispatcherEtaShareInfo, DriverEtaShareInfo } from '../services/api/domains/EtaShare';

enum Events {
    TRY_DISPATCHER_BUTTON = 'tryDispatcherButton'
}

export enum InitiatedFrom {
    HEADER_SHARE_BUTTON = 'headerShareButton',
    BLANK_SHARE_BUTTON = 'blankShareButton',
    TEASER_SHARE_BUTTON = 'teaserShareButton'
}

export class CustomUserEvents {
    static pushEvent(event: string, params?: any) {
        (window as any).dataLayer.push({
            event,
            ...params
        });
    }

    static tryDispatcherButton(
        initiatedFrom: InitiatedFrom,
        params?: DriverEtaShareInfo | DispatcherEtaShareInfo | null
    ) {
        const remainingTime = moment(params?.route?.eta).diff(moment());

        CustomUserEvents.pushEvent(Events.TRY_DISPATCHER_BUTTON, {
            driveStatus: params?.sharingState,
            driveRemaining_distance: params?.route?.remainingDistance,
            driveTimeLeft: remainingTime > 0 ? moment.duration(remainingTime).minutes() : 0,
            driveEta: params?.route?.eta,
            driveDriver: (params as DriverEtaShareInfo)?.driverName || '',
            driveCompany: (params as DispatcherEtaShareInfo)?.companyName,
            driveDestination: params?.route?.destination.address,
            driveLanguage: i18next.language,
            driveInitiatedFrom: initiatedFrom
        });
    }
}
